import styled from 'styled-components';

export const WhyLearnJavaWrapper = styled.div`
.text-align-justify{
    text-align: justify;
}
.entry-title {
    font-weight: 600;
    font-size: 1.9rem;
    text-align: center;
}
.text-align-left{
    text-align: left;
}
.accordion-button {
    color: black;
    background-color: #e7faca;
    font-weight: bold;
    font-family: Times New Roman;
    font-size: 20px;
    letter-spacing:0.5px;
    font-style: italic;
}
p, li {
    color: #334155;
}
p, h6, li {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: #334155;
}
img {
    box-sizing: border-box;
    height: auto;
    max-width: 100%;
    vertical-align: bottom;
}
.reduced-img{
    width: '60%';
    height:auto;
}
/* Media query for mobile devices (screen width 768px and below) */
@media screen and (max-width: 768px) {
  .reduced-img{
    width: 80%
  }
}
`;
